export const commonTheme = {
  positiveSurface: '#2cc68f',
  warningSurface: '#ffe443',
};
